import type { Step } from '@/components/wizard/Step';

import type { RdsCdcWizardState } from './rdsCdcWizardState';
import { AwsPrivateLinkStep } from './steps/AwsPrivateLinkStep';
import { FinalChecksStep } from './steps/FinalChecksStep';
import { SqlCommandsStep } from './steps/SqlCommandsStep';

export const RdsCdcFlow: Step<RdsCdcWizardState> = {
  id: 'aws_privatelink_setup',
  Component: AwsPrivateLinkStep,
  next: [
    {
      id: 'sql_commands',
      Component: SqlCommandsStep,
      next: [
        {
          id: 'final_checks',
          Component: FinalChecksStep,
        },
      ],
    },
  ],
};
